// extracted by mini-css-extract-plugin
module.exports = {"root":"Invoice_root__3pDnv","open":"Invoice_open__cVu1I"};